import React, {useState} from "react";
import {useStyles} from "./style";
import {PromoBannerProps} from "./type";
import ReactModal from "react-modal";
import {RefButton} from "../like-button-ref/like-button-ref";
import classNames from "classnames";

ReactModal.setAppElement("#___gatsby");

export const PromoBanner = (props: PromoBannerProps) => {

    const classes = useStyles();

    const [modalIsOpen, setIsOpenModal] = useState(false);

    function modalOpenHandle() {
        setIsOpenModal(true);
    }

    function modalCloseHandle() {
        setIsOpenModal(false);
    }

    function getYoutubeVideoIdByUrl(url: string) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const matchValue = url.match(regExp);

        if (matchValue && matchValue[7].length === 11) {
            return matchValue[7];
        }

        return false;
    }

    return (
        <>
            <div className={classes.promoBanner}>
                <div
                    className={classNames(
                        classes.promoBannerVideoPreview,
                        {[classes.withVideo]: getYoutubeVideoIdByUrl(props.bannerMediaUrl)}
                    )}
                    onClick={getYoutubeVideoIdByUrl(props.bannerMediaUrl) ? modalOpenHandle : void(0)}
                >
                    <img
                        className={classes.promoBannerVideoThumbnail}
                        src={getYoutubeVideoIdByUrl(props.bannerMediaUrl) ? `https://i.ytimg.com/vi/${getYoutubeVideoIdByUrl(props.bannerMediaUrl)}/mq2.jpg` : props.bannerMediaUrl}
                        alt=""
                    />
                    {getYoutubeVideoIdByUrl(props.bannerMediaUrl) &&
                        <div className={classes.promoBannerVideoThumbnailText}>
                            {props.bannerMediaText}
                        </div>
                    }
                </div>
                <div className={"h3 " + classes.promoBannerText}>
                    {props.bannerText}
                </div>
                <div className={classes.promoButton}>
                    <RefButton
                        text="Contact us"
                        variant="primary"
                        size="md"
                    />
                </div>
            </div>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={modalCloseHandle}
                className={classes.promoBannerModal}
            >
                <button className={"modalCloseBtn"} onClick={modalCloseHandle}></button>
                <iframe
                    src={`https://www.youtube.com/embed/${getYoutubeVideoIdByUrl(props.bannerMediaUrl)}?autoplay=1&modestbranding=1&rel=0`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className={classes.promoBannerVideo}
                ></iframe>
                <RefButton
                    text="Contact us"
                    variant="primary"
                    size="lg"
                    classNames={classes.promoBannerModalBtn}
                />
            </ReactModal>
        </>
    );
};
